// extracted by mini-css-extract-plugin
module.exports = {"outer":"_1F-QN","leftWrapper":"_3fbj_","heading":"_2Sn7H","subHeading":"_3I-hi","rightWrapper":"_4vY2"};